<template>
  <div class="dashboard">
    <div class="step" v-for="step in steps" :key="step.name">
      <step-dash
        :name="step.name"
        :status="step.status"
        :textButton="step.textButton"
        :textDesc="step.textDesc"
        :sessions="sessions"
        :loaderButton="loaderButton"
      ></step-dash>
    </div>
    <alert-schedule
      v-if="openAlert"
      :date="dateSchedule"
      :time="timeSchedule"
      @closeAlert="openAlert = false"
    ></alert-schedule>
    <loader-request v-if="openLoader"></loader-request>
    <loader-full v-if="openLoaderFull"></loader-full>
  </div>
</template>
<script>
import middleware from "../middleware/middleware.js";
import StepDash from "../components/Dashboard/StepDash";
import AlertSchedule from "../components/Alerts/AlertSchedule";
import LoaderRequest from "../components/Loaders/LoaderRequest";
import LoaderFull from "../components/Loaders/LoaderFull";
import Bus from "@/main.js";
import decodeApi from "../api/decode";
import {tagManager} from "../helpers/integrationManager"
var moment = require("moment");
moment.locale("pt-br");
export default {
  components: {
    StepDash,
    AlertSchedule,
    LoaderRequest,
    LoaderFull,
  },
  props: {
    status: {
      type: String,
    },
    scheduleTime: {
      type: String,
    },
  },
  data() {
    return {
      userId: "",
      steps: [],
      sessions: [],
      openAlert: false,
      openLoader: false,
      openLoaderFull: false,
      dateSchedule: "",
      timeSchedule: "",
      loaderButton: true,
    };
  },
  async created() {

    Bus.$on("schedule", this.schedule);
    const {
      workspaceId,
      workspaceTitle,
      token,
      userId,
      teamGameId,
    } = await this.$store.getters.getSimple([
      "workspaceId",
      "workspaceTitle",
      "token",
      "userId",
      "teamGameId",
    ]);
    this.userId = userId;
    if (this.status) {
      let scheduleObject = new Object();
      scheduleObject.status = this.status;
      scheduleObject.schedule = this.scheduleTime;
      let newStatusSchedule = await middleware.verifyTeamGame(
        scheduleObject,
        teamGameId,
        userId,
        workspaceId
      );
      if (newStatusSchedule.schedule) {
        this.$store.dispatch("simpleSave", {
          scheduleTime: newStatusSchedule.schedule,
        });
      }
      await this.defineStatusRedirect(newStatusSchedule);
      await this.getSessionsWorkspace(workspaceId);
      return;
    }
    this.openLoaderFull = true;
    if (!token) {
      middleware.redirectAuth();
      return;
    }
    let authenticated = await middleware.verifyAuth(token);
    if (!authenticated) {
      middleware.redirectAuth();
      return;
    }
    if (!workspaceTitle) {
      await middleware.getWorkspace(workspaceId);
    }
    let statusSchedule = await middleware.verifySchedule(userId, workspaceId);
    this.$store.dispatch("simpleSave", {
      scheduleTime: statusSchedule.schedule,
    });
    // console.log(statusSchedule);
    let newStatusSchedule = await middleware.verifyTeamGame(
      statusSchedule,
      teamGameId,
      userId,
      workspaceId
    );
    // console.log(newStatusSchedule);
    await this.defineStatusRedirect(newStatusSchedule);
    await this.getSessionsWorkspace(workspaceId);
    const { scheduling } = await this.$store.getters.getSimple(["scheduling"]);
    if (scheduling) {
      let schedulings = JSON.parse(scheduling);
      await this.watchingStatusDash(newStatusSchedule, schedulings.schedulings);
    }
  },
  methods: {
    watchingStatusDash(status, scheduling) {
      // console.log(status);
      if (status.status == "coming soon" || status.status == "started") {
        setInterval(async () => {
          // console.log("atualizou");
          const newStatus = await middleware.statusScheduling(scheduling);
          await this.defineStatusRedirect(newStatus);
        }, 60000);
      }
    },
    getSessionsWorkspace(workspaceId) {
      let self = this;
      decodeApi
        .get(`/sessions/by-workspace?workspaceId=${workspaceId}`)
        .then((response) => {
          self.loaderButton = false;
          let now = moment();
          let arraySessions = response.data.sessions;
          if (!arraySessions.length) {
            arraySessions = [response.data.sessions];
          }
          let sessoes = arraySessions.filter((sessao) => {
            return sessao.fields.status == "open";
          });
          self.sessions = sessoes;
          // console.log("self.sessions: ", self.sessions)
          self.openLoaderFull = false;
        })
        .catch((error) => {
          //TODO: make a error message showing up instead console.log error
          // console.log(error);
          self.loaderButton = false;
          self.openLoaderFull = false;
        });
    },
    defineStatusRedirect(status) {
      let schedule = status.schedule;
      let date = moment(schedule).format("DD/MM/YYYY");
      let time = moment(schedule).format("HH:mm:ss");
      let timeMore = moment(schedule).add(10, "minutes").format("HH:mm:ss");
      let timeLess = moment(schedule)
        .subtract(10, "minutes")
        .format("HH:mm:ss");
      switch (status.status) {
        case "finished":
          this.steps = [
            {
              name: "schedule",
              status: "finished",
              textButton: this.$t("views.Dashboard.steps.finished[0]"),
              textDesc: this.$t("views.Dashboard.steps.finished[1]"),
            },
            {
              name: "game",
              status: "finished",
              textButton: this.$t("views.Dashboard.steps.finished[2]"),
              textDesc: this.$t("views.Dashboard.steps.finished[3]"),
            },
            {
              name: "report",
              status: "disabled",
              textButton: this.$t("views.Dashboard.steps.finished[4]"),
              textDesc: this.$t("views.Dashboard.steps.finished[5]"),
            },
          ];
          break;
        case "expired":
          this.steps = [
            {
              name: "schedule",
              status: "scheduled-expired",
              textButton: this.$t("views.Dashboard.steps.expired[0]"),
              textDesc: this.$t("views.Dashboard.steps.expired[1]"),
            },
            {
              name: "game",
              status: "expired",
              textButton: this.$t("views.Dashboard.steps.expired[2]"),
              textDesc: this.$t("views.Dashboard.steps.expired[3]"),
            },
            {
              name: "report",
              status: "disabled",
              textButton: this.$t("views.Dashboard.steps.expired[4]"),
              textDesc: this.$t("views.Dashboard.steps.expired[5]"),
            },
          ];
          break;
        case "started":
          this.steps = [
            {
              name: "schedule",
              status: "scheduled",
              textButton: this.$t("views.Dashboard.steps.started[0]"),
              textDesc: `
                ${this.$t("views.Dashboard.steps.started[1]")} 
                ${date} 
                ${this.$t("views.Dashboard.steps.started[2]")}
                ${time} 
                ${this.$t("views.Dashboard.steps.started[3]")}`, // alterar com a data da sessão
            },
            {
              name: "game",
              status: "started-game",
              textButton: this.$t("views.Dashboard.steps.started[4]"),
              textDesc: 
                `${this.$t("views.Dashboard.steps.started[5]")} 
                ${timeMore}
                ${this.$t("views.Dashboard.steps.started[6]")} `, // alterar com a data da sessão
            },
            {
              name: "report",
              status: "disabled",
              textButton: this.$t("views.Dashboard.steps.started[7]"),
              textDesc: this.$t("views.Dashboard.steps.started[8]"),
            },
          ];
          break;
        case "in progress":
          this.steps = [
            {
              name: "schedule",
              status: "scheduled",
              textButton: this.$t("views.Dashboard.steps.inProgress[0]"),
              textDesc: 
              `${this.$t("views.Dashboard.steps.inProgress[1]")}
              ${date} 
              ${this.$t("views.Dashboard.steps.inProgress[2]")} 
              ${time} 
              ${this.$t("views.Dashboard.steps.inProgress[3]")}`, // alterar com a data da sessão
            },
            {
              name: "game",
              status: "started-game",
              textButton: this.$t("views.Dashboard.steps.inProgress[4]"),
              textDesc:  this.$t("views.Dashboard.steps.inProgress[5]"), // alterar com a data da sessão
            },
            {
              name: "report",
              status: "disabled",
              textButton: this.$t("views.Dashboard.steps.inProgress[6]"),
              textDesc: this.$t("views.Dashboard.steps.inProgress[7]"),
            },
          ];
          break;
        case "coming soon":
          this.steps = [
            {
              name: "schedule",
              status: "scheduled",
              textButton: this.$t("views.Dashboard.steps.comingSoon[0]"),
              textDesc: 
              `${this.$t("views.Dashboard.steps.comingSoon[1]")} 
              ${date} 
              ${this.$t("views.Dashboard.steps.comingSoon[2]")}  
              ${time} 
              ${this.$t("views.Dashboard.steps.comingSoon[3]")} `, // alterar com a data da sessão
            },
            {
              name: "game",
              status: "scheduled-game",
              textButton: this.$t("views.Dashboard.steps.comingSoon[4]"),
              textDesc: 
              `${this.$t("views.Dashboard.steps.comingSoon[5]")}  
              ${moment(schedule).subtract("minutes", 10).format("HH:mm:ss")} 
              ${this.$t("views.Dashboard.steps.comingSoon[3]")} 
              ${this.$t("views.Dashboard.steps.comingSoon[6]")} 
              ${date}`, // alterar com a data da sessão
            },
            {
              name: "report",
              status: "disabled",
              textButton: this.$t("views.Dashboard.steps.comingSoon[7]"),
              textDesc: this.$t("views.Dashboard.steps.comingSoon[8]"),
            },
          ];
          break;
        case "not scheduled":
          this.steps = [
            {
              name: "schedule",
              status: "dash-open",
              textButton: this.$t("views.Dashboard.steps.notScheduled[0]"),
              textDesc: this.$t("views.Dashboard.steps.notScheduled[1]"),
            },
            {
              name: "game",
              status: "disabled",
              textButton: this.$t("views.Dashboard.steps.notScheduled[2]"),
              textDesc: this.$t("views.Dashboard.steps.notScheduled[3]"),
            },
            {
              name: "report",
              status: "disabled",
              textButton: this.$t("views.Dashboard.steps.notScheduled[4]"),
              textDesc: this.$t("views.Dashboard.steps.notScheduled[5]"),
            },
          ];
          break;
        case "report":
          this.steps = [
            {
              name: "schedule",
              status: "finished",
              textButton: this.$t("views.Dashboard.steps.report[0]"),
              textDesc: this.$t("views.Dashboard.steps.report[1]"),
            },
            {
              name: "game",
              status: "finished",
              textButton: this.$t("views.Dashboard.steps.report[2]"),
              textDesc:  this.$t("views.Dashboard.steps.report[3]"),
            },
            {
              name: "report",
              status: "open",
              textButton: this.$t("views.Dashboard.steps.report[4]"),
              textDesc: this.$t("views.Dashboard.steps.report[5]"),
            },
          ];
      }
      return;
    },

    async schedule(sessionId) {
      this.openLoader = true;
      let userId = JSON.parse(localStorage.getItem("player")).data.id;
      const workspaceId = localStorage.getItem("workspaceId")
      let responseSchedule = "";
      const {
        sessionSchedule,
        schedulingId,
      } = await this.$store.getters.getSimple([
        "sessionSchedule",
        "schedulingId",
      ]);
      if (sessionSchedule) {
        // console.log("reagendar");
        responseSchedule = await decodeApi.patch(
          `/schedulings/${schedulingId}/reschedule`,
          {
            sessionId,
          }
        );
      } else {
        // console.log("agendar");
        // console.log("USER ID: ", userId);
        responseSchedule = await decodeApi.post(`/schedulings`, {
          userId,
          sessionId: sessionId,
        });
      }
      // console.log(responseSchedule);
      this.dateSchedule = moment(responseSchedule.data.session.schedule).format(
        "DD/MM/YYYY"
      );
      this.timeSchedule = moment(responseSchedule.data.session.schedule).format(
        "HH:mm"
      );
      //TODO: Adicionar aqui a funcão de tags
      if(this.$store.getters.getWsWithTagManager.includes(workspaceId)){
        const { data: player } = JSON.parse(localStorage.getItem("player"))
        delete player.cpf
        const tag = "Agendou" + " - " + this.dateSchedule + " " + this.timeSchedule
        await tagManager(tag ,workspaceId, player)
      }
      let status = await middleware.statusScheduling(responseSchedule.data);
      await this.defineStatusRedirect(status);
      this.openLoader = false;
      this.openAlert = true;
      this.$store.dispatch("simpleSave", {
        scheduleTime: responseSchedule.data.session.schedule,
        sessionId,
        sessionSchedule: sessionId,
        schedulingId: responseSchedule.data.scheduling.id,
      });
      await this.watchingStatusDash(status, responseSchedule.data);
    },
  },
};
</script>
<style lang="scss" scoped>
.dashboard {
  height: calc(100vh - 65px);
  display: flex;
  flex-direction: column;

  .step {
    height: calc((100vh - 65px) / 3);
  }
}

@media only screen and (min-width: 750px) {
  .dashboard {
    height: calc(100% - 65px);
    display: flex;
    flex-direction: column;

    .step {
      height: calc(100% / 3);
    }
  }
}
</style>
